import React from 'react';

import { SubHeading } from '../../Components';
import { images } from '../../constants';
import './Header.css';

const Header = () => (
<div className="app__header app__wrapper section__padding" id="home">
      <div className="app__wrapper_info" data-aos="fade-up">
        <SubHeading title="Dine. In. Excellence." />
        <h1 className="app__header-h1">The Essence of Gourmet Dining</h1>
        <p className="p__opensans" style={{ margin: '2rem 0' }}>
          Immerse yourself in a culinary journey where every detail is meticulously crafted. From exquisite flavors to impeccable service, discover a dining experience that transcends the ordinary.
        </p>
        <a href="#menu"><button type="button" className="custom__button" data-aos="zoom-in">Explore Menu</button></a>
      </div>

      <div className="app__wrapper_img" data-aos="fade-left">
        <img src={images.welcome} alt="header_img" />
      </div>
    </div>
  );

export default Header;